import { useEffect, useState } from "react";
import { buscarVisualizacoesByAnuncioIdService } from "../../../services/buscarVisualizacoesByAnuncioIdService";

export const useVisualizacao = (idAnuncio: number | null) => {
  const [visualizacoes, setVisualizacoes] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetch = async () => {
      if (idAnuncio) {
        setLoading(true);
        try {
          const data = await buscarVisualizacoesByAnuncioIdService(idAnuncio);
          if (data) {
            setVisualizacoes(data.length);
          }
        } catch (err) {
          console.error("Erro ao buscar visualizações:", err);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };

    fetch();
  }, [idAnuncio]);

  return { visualizacoes, loading };
};
